import { DocsAnalyticsComparisonData } from "./SDKDocsAnalyticsComparisonData";
import { DocsAnalyticsPageComparisonData } from "./SDKDocsAnalyticsPageComparisonData";
import { DocsAnalyticsPageVisitData } from "./SDKDocsAnalyticsPageVisitData";
import { DocsAnalyticsVisitData } from "./SDKDocsAnalyticsVisitData";
import { DocsAnalyticsVisitHeatMapWeek } from "./SDKDocsAnalyticsVisitHeatMapWeek";
export class DocsAnalyticsData {
    constructor(model) {
        this.globalAnalytics = model.globalAnalytics.map((e) => new DocsAnalyticsVisitData(e));
        this.pageAnalytics = model.pageAnalytics.map((e) => new DocsAnalyticsPageVisitData(e));
        this.heatMapData = model.heatMapData.map((e) => new DocsAnalyticsVisitHeatMapWeek(e));
        this.comparisonData = model.comparisonData.map((e) => new DocsAnalyticsComparisonData(e));
        this.pageComparisonData = model.pageComparisonData.map((e) => new DocsAnalyticsPageComparisonData(e));
    }
}
